/**
 * This file was automatically generated and should not be edited.
 * Source: tokens.json from Figma variables (/sync-design-tokens) via scripts/generateTokensFromFigma.mjs
 */
/**
 * spacing: 0px
 */
export const SPACE_0 = 'var(--space-0)';
/**
 * spacing: 2px
 */
export const SPACE_050 = 'var(--space-050)';
/**
 * spacing: 4px
 */
export const SPACE_100 = 'var(--space-100)';
/**
 * spacing: 6px
 */
export const SPACE_150 = 'var(--space-150)';
/**
 * spacing: 8px
 */
export const SPACE_200 = 'var(--space-200)';
/**
 * spacing: 10px
 */
export const SPACE_250 = 'var(--space-250)';
/**
 * spacing: 12px
 */
export const SPACE_300 = 'var(--space-300)';
/**
 * spacing: 16px
 */
export const SPACE_400 = 'var(--space-400)';
/**
 * spacing: 20px
 */
export const SPACE_500 = 'var(--space-500)';
/**
 * spacing: 24px
 */
export const SPACE_600 = 'var(--space-600)';
/**
 * spacing: 28px
 */
export const SPACE_650 = 'var(--space-650)';
/**
 * spacing: 32px
 */
export const SPACE_700 = 'var(--space-700)';
/**
 * spacing: 40px
 */
export const SPACE_800 = 'var(--space-800)';
/**
 * spacing: 48px
 */
export const SPACE_900 = 'var(--space-900)';
/**
 * spacing: 56px
 */
export const SPACE_1000 = 'var(--space-1000)';
/**
 * spacing: 64px
 */
export const SPACE_1100 = 'var(--space-1100)';
/**
 * spacing: 72px
 */
export const SPACE_1200 = 'var(--space-1200)';
/**
 * spacing: 80px
 */
export const SPACE_1300 = 'var(--space-1300)';
/**
 * spacing: 88px
 */
export const SPACE_1400 = 'var(--space-1400)';
/**
 * spacing: 96px
 */
export const SPACE_1500 = 'var(--space-1500)';
